import React, { useEffect, useState } from "react";

import Input from "../../../Inputs/InputText";
import SelectInput from "../../../Inputs/SelectInput";
import Spacer from "../../../Spacer";
import { RelativeDateValue } from "../../QueryBuilderUtils";

interface UnitOfTimeMap {
	value: string;
	label: string;
}

const UNIT_OF_TIME = [
	{ value: "days", label: "Days Ago" },
	{ value: "months", label: "Months Ago" },
	{ value: "years", label: "Years Ago" },
];

declare interface DynamicEmployeesQueryBuilderProps {
	value?: RelativeDateValue;
	onChange: (value: RelativeDateValue) => void;
	unitOfTimeMap?: UnitOfTimeMap[];
}

const RelativeQueryDatePicker = ({
	value,
	onChange,
	unitOfTimeMap = UNIT_OF_TIME,
}: DynamicEmployeesQueryBuilderProps) => {
	const [numberOfUnits, setNumberOfUnits] = useState<number>(value?.length || 0);
	const [unitOfTime, setUnitOfTime] = useState<string>(value?.unit || unitOfTimeMap[0].value);
	// is this an acceptable solution? set to null if it does not exist -> populate inputs empty if so

	useEffect(() => {
		if (numberOfUnits != null && unitOfTime != null) {
			onChange({ length: numberOfUnits, unit: unitOfTime } as RelativeDateValue);
		}
	}, [numberOfUnits, unitOfTime]);

	return (
		<div>
			<Input
				type={"number"}
				value={String(numberOfUnits)}
				placeholder={"Enter numeric value"}
				onChange={(input) => setNumberOfUnits(Number(input))}
			/>
			<Spacer height={1} />
			<SelectInput
				value={unitOfTime ? unitOfTime : unitOfTimeMap[0].value}
				results={unitOfTimeMap}
				onChange={(input) => setUnitOfTime(input.value)}
				placeholder="Select duration"
			/>
		</div>
	);
};

export default RelativeQueryDatePicker;
